import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
	const [language, setLanguage] = useState(() => localStorage.getItem('lang') || 'nl');

	const toggleLanguage = () => {
		const next = language === 'nl' ? 'en' : 'nl';
		setLanguage(next);
		localStorage.setItem('lang', next);
	};

	return (
		<LanguageContext.Provider value={{ language, toggleLanguage }}>
			{children}
		</LanguageContext.Provider>
	);
};

export const useLanguage = () => useContext(LanguageContext);
